import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import BrandsComparisionDetail from "./BrandsComparisionDetail";

class BrandsDoubleComparisionPersona extends Component {
  constructor(props) {
    super(props);

    this.state = {
     // selectedRadioButton: 'index',
    };
  }

  resize = (arr, newSize, defaultValue) => {
    while (newSize > arr.length) arr.push(defaultValue);
  }

  fill(brandsOrMedia) {
    if (brandsOrMedia.length < 10) {
      this.resize(brandsOrMedia, 10, {
        brandCategory: 'N/A',
        brandLabel: 'N/A',
        icon: 'clear-field-icon_190-190-190.png',
        index: 'N/A',
        weighted: 'N/A',
        sample: 'N/A',
        pct: 'N/A',
      });
    }
    return brandsOrMedia;
  }

  render() {
    let brandsPersonaList = [];
    if (this.props.brands !== undefined) {
      brandsPersonaList = this.props.brands;
    }

    return (
      <div className="row fullwidth brandsCardPdf">
        <div className="row fullwidth demographic-detail-columns">
          {!_.isEmpty(brandsPersonaList) &&
            brandsPersonaList.length > 0 &&
            brandsPersonaList.map((brand, index) => (<div key={index}>
              <div className="columns large-6 medium-6 small-6 brandsDoublePersonaPdf">
                {this.fill(brand.brandList.slice(0, 10)).map((brand, i) => (<div
                  className="row fullwidth demographic-detail-columns"
                  key={`brand-d${index}${i}`}
                >
                  <div className="columns large-12 small-12 medium-12">
                      <BrandsComparisionDetail
                        key={i}
                        brandCategory={brand.brandCategory}
                        statement={brand.brandLabel}
                        brandDetail={brand}
                        personaIndex={index}
                        selectedTab={this.props.selectedTab}
                        selectedIcon={_.camelCase(
                          brand.icon.replace('.png', ''),
                        )}
                      />
                  </div>
                </div>
                )
                )}
              </div>
            </div>
            )
            )}
        </div>
      </div>
    );
  }
}

BrandsDoubleComparisionPersona.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.object),
  selectedTab: PropTypes.string,
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(BrandsDoubleComparisionPersona);
